const REGEX_ENTER = /\r?\n/

function convertToQuestion(questionId, question, index): ComplianceQuestion {
  const questionSubtext = question.subText
    ? question.subText.split(REGEX_ENTER)
    : undefined

  const number = index + 1
  const ico = (index % 5) + 1

  const answerOptions = Object.keys(question.possibleAnswers)
    .sort((a, b) =>
      question.possibleAnswers[a].localeCompare(question.possibleAnswers[b])
    )
    .map(answerId => {
      return { valueText: answerId, label: question.possibleAnswers[answerId] }
    })

  return {
    id: +questionId,
    questionSubtext,
    number,
    ico,
    question: question.text,
    warning: question.warnings,
    answerOptions,
    possibleAnswers: question.possibleAnswers,
    expectedAnswers: question.expectedAnswers
  }
}

export default convertToQuestion
